import React from "react";

const TickUnChangedIcon = ({ 
  width = 57, 
  height = 57, 
  className = "",
  ...props 
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Main gradient background */}
      <path
        d="M48.2982 6.74031L33.1307 2.45781C27.629 0.904432 23.5626 3.39445 22.0836 9.21079L17.0744 28.9101C15.5711 34.8218 17.9306 39.0444 23.4323 40.5977L38.5998 44.8802C44.1901 46.4587 48.1466 44.0194 49.6499 38.1077L54.6591 18.4084C56.1381 12.5921 53.8885 8.31873 48.2982 6.74031Z"
        fill="url(#paint0_linear_541_11003)"
      />
      
      {/* Blur effect background */}
      <g opacity="0.5" filter="url(#filter0_f_541_11003)">
        <path
          d="M44.3348 12.1391L34.001 9.2214C30.2527 8.16307 27.4822 9.85955 26.4746 13.8223L23.0617 27.2436C22.0376 31.2713 23.6451 34.1482 27.3934 35.2065L37.7272 38.1242C41.5359 39.1996 44.2315 37.5377 45.2557 33.51L48.6686 20.0887C49.6762 16.126 48.1435 13.2145 44.3348 12.1391Z"
          fill="#01BBFE"
        />
      </g>
      
      {/* Backdrop blur effect */}
      <foreignObject x="-16.8563" y="-7.28608" width="78.8263" height="81.1432">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(8.65px)",
            clipPath: "url(#bgblur_0_541_11003_clip_path)",
            height: "100%",
            width: "100%"
          }}
        />
      </foreignObject>
      
      {/* Rounded rectangle background with mask */}
      <g data-figma-bg-blur-radius="17.3">
        <mask
          id="path-3-outside-1_541_11003"
          maskUnits="userSpaceOnUse"
          x="0"
          y="9.57031"
          width="45"
          height="47"
          fill="black"
        >
          <rect fill="white" y="9.57031" width="45" height="47" />
          <path d="M31.9125 10.5703H13.2227C5.91496 10.5703 1 15.9765 1 24.0177V42.5761C1 50.5946 5.91496 56.0008 13.2227 56.0008H31.9125C39.2203 56.0008 44.1137 50.5946 44.1137 42.5761V24.0177C44.1137 15.9765 39.2203 10.5703 31.9125 10.5703Z" />
        </mask>
        <path
          d="M31.9125 10.5703H13.2227C5.91496 10.5703 1 15.9765 1 24.0177V42.5761C1 50.5946 5.91496 56.0008 13.2227 56.0008H31.9125C39.2203 56.0008 44.1137 50.5946 44.1137 42.5761V24.0177C44.1137 15.9765 39.2203 10.5703 31.9125 10.5703Z"
          fill="#01BBFE"
          fillOpacity="0.02"
        />
        <path
          d="M31.9125 11.1266C32.2198 11.1266 32.4688 10.8775 32.4688 10.5703C32.4688 10.2631 32.2198 10.014 31.9125 10.014V10.5703V11.1266ZM31.9125 10.014C31.6053 10.014 31.3562 10.2631 31.3562 10.5703C31.3562 10.8775 31.6053 11.1266 31.9125 11.1266V10.5703V10.014ZM31.9125 10.5703V10.014H13.2227V10.5703V11.1266H31.9125V10.5703ZM13.2227 10.5703V10.014C9.42424 10.014 6.21484 11.423 3.95931 13.9044C1.708 16.3811 0.443709 19.8846 0.443709 24.0177H1H1.55629C1.55629 20.1097 2.74949 16.8894 4.7826 14.6528C6.81149 12.4207 9.71347 11.1266 13.2227 11.1266V10.5703ZM1 24.0177H0.443709V42.5761H1H1.55629V24.0177H1ZM1 42.5761H0.443709C0.443709 46.6982 1.70822 50.196 3.95953 52.6698C6.21501 55.1481 9.42427 56.5571 13.2227 56.5571V56.0008V55.4445C9.71343 55.4445 6.81132 54.1503 4.78237 51.9209C2.74926 49.6869 1.55629 46.4724 1.55629 42.5761H1ZM13.2227 56.0008V56.5571H31.9125V56.0008V55.4445H13.2227V56.0008ZM31.9125 56.0008V56.5571C35.7111 56.5571 38.9153 55.148 41.1654 52.6693C43.4113 50.1953 44.67 46.6976 44.67 42.5761H44.1137H43.5574C43.5574 46.473 42.3695 49.6877 40.3417 51.9214C38.3182 54.1505 35.4217 55.4445 31.9125 55.4445V56.0008ZM44.1137 42.5761H44.67V24.0177H44.1137H43.5574V42.5761H44.1137ZM44.1137 24.0177H44.67C44.67 19.8852 43.4115 16.3819 41.1657 13.9049C38.9154 11.4231 35.7112 10.014 31.9125 10.014V10.5703V11.1266C35.4217 11.1266 38.318 12.4206 40.3414 14.6522C42.3692 16.8887 43.5574 20.109 43.5574 24.0177H44.1137Z"
          fill="url(#paint1_linear_541_11003)"
          mask="url(#path-3-outside-1_541_11003)"
        />
      </g>
      
      {/* Second backdrop blur effect */}
      <foreignObject x="4.65172" y="17.5619" width="35.8097" height="31.4456">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(4.17px)",
            clipPath: "url(#bgblur_1_541_11003_clip_path)",
            height: "100%",
            width: "100%"
          }}
        />
      </foreignObject>
      
      {/* Checkmark icon with drop shadow */}
      <g filter="url(#filter2_d_541_11003)" data-figma-bg-blur-radius="8.34437">
        <mask id="path-5-inside-2_541_11003" fill="white">
          <path d="M19.9988 40.6632C19.516 40.6632 19.0331 40.4701 18.6645 40.0817L13.549 34.6914C12.8118 33.9145 12.8118 32.6561 13.549 31.8815C14.2863 31.1046 15.4784 31.1024 16.2156 31.8792L19.9988 35.8657L28.8975 26.4889C29.6348 25.712 30.8269 25.712 31.5641 26.4889C32.3013 27.2658 32.3013 28.5242 31.5641 29.301L21.3332 40.0817C20.9646 40.4701 20.4817 40.6632 19.9988 40.6632Z" />
        </mask>
        <path
          d="M19.9988 40.6632C19.516 40.6632 19.0331 40.4701 18.6645 40.0817L13.549 34.6914C12.8118 33.9145 12.8118 32.6561 13.549 31.8815C14.2863 31.1046 15.4784 31.1024 16.2156 31.8792L19.9988 35.8657L28.8975 26.4889C29.6348 25.712 30.8269 25.712 31.5641 26.4889C32.3013 27.2658 32.3013 28.5242 31.5641 29.301L21.3332 40.0817C20.9646 40.4701 20.4817 40.6632 19.9988 40.6632Z"
          fill="url(#paint2_linear_541_11003)"
        />
        <path
          d="M18.6645 40.0817L18.5838 40.1583L18.6645 40.0817ZM13.549 31.8815L13.6296 31.9582L13.6297 31.9581L13.549 31.8815ZM19.9988 35.8657L19.9181 35.9423L19.9988 36.0274L20.0795 35.9423L19.9988 35.8657ZM28.8975 26.4889L28.8168 26.4123L28.8975 26.4889ZM31.5641 29.301L31.4834 29.2245L31.5641 29.301ZM21.3332 40.0817L21.4139 40.1583L21.3332 40.0817ZM19.9988 40.6632V40.5519C19.546 40.5519 19.0925 40.3711 18.7452 40.0051L18.6645 40.0817L18.5838 40.1583C18.9737 40.5692 19.4859 40.7745 19.9988 40.7745V40.6632ZM18.6645 40.0817L18.7452 40.0051L13.6297 34.6148L13.549 34.6914L13.4683 34.768L18.5838 40.1583L18.6645 40.0817ZM13.549 34.6914L13.6297 34.6148C12.9332 33.8808 12.9333 32.6898 13.6296 31.9582L13.549 31.8815L13.4684 31.8048C12.6902 32.6224 12.6904 33.9482 13.4683 34.768L13.549 34.6914ZM13.549 31.8815L13.6297 31.9581C14.3233 31.2273 15.4417 31.2254 16.1349 31.9558L16.2156 31.8792L16.2963 31.8026C15.515 30.9794 14.2493 30.982 13.4683 31.8049L13.549 31.8815ZM16.2156 31.8792L16.1349 31.9558L19.9181 35.9423L19.9988 35.8657L20.0795 35.7892L16.2963 31.8026L16.2156 31.8792ZM19.9988 35.8657L20.0795 35.9423L28.9782 26.5655L28.8975 26.4889L28.8168 26.4123L19.9181 35.7892L19.9988 35.8657ZM28.8975 26.4889L28.9782 26.5655C29.6716 25.8349 30.79 25.8349 31.4834 26.5655L31.5641 26.4889L31.6448 26.4123C30.8637 25.5892 29.5979 25.5892 28.8168 26.4123L28.8975 26.4889ZM31.5641 26.4889L31.4834 26.5655C32.1799 27.2994 32.1799 28.4905 31.4834 29.2245L31.5641 29.301L31.6448 29.3776C32.4228 28.5578 32.4228 27.2321 31.6448 26.4123L31.5641 26.4889ZM31.5641 29.301L31.4834 29.2245L21.2525 40.0051L21.3332 40.0817L21.4139 40.1583L31.6448 29.3776L31.5641 29.301ZM21.3332 40.0817L21.2525 40.0051C20.9052 40.3711 20.4517 40.5519 19.9988 40.5519V40.6632V40.7745C20.5118 40.7745 21.024 40.5692 21.4139 40.1583L21.3332 40.0817Z"
          fill="url(#paint3_linear_541_11003)"
          fillOpacity="0.5"
          mask="url(#path-5-inside-2_541_11003)"
        />
      </g>
      
      {/* Definitions */}
      <defs>
        <filter
          id="filter0_f_541_11003"
          x="14.971"
          y="1.12476"
          width="41.7875"
          height="45.1072"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="3.89404" result="effect1_foregroundBlur_541_11003" />
        </filter>
        
        <clipPath id="bgblur_0_541_11003_clip_path" transform="translate(16.8563 7.28608)">
          <path d="M31.9125 10.5703H13.2227C5.91496 10.5703 1 15.9765 1 24.0177V42.5761C1 50.5946 5.91496 56.0008 13.2227 56.0008H31.9125C39.2203 56.0008 44.1137 50.5946 44.1137 42.5761V24.0177C44.1137 15.9765 39.2203 10.5703 31.9125 10.5703Z" />
        </clipPath>
        
        <filter
          id="filter2_d_541_11003"
          x="4.65172"
          y="17.5619"
          width="35.8097"
          height="31.4456"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2.78146" dy="2.78146" />
          <feGaussianBlur stdDeviation="2.78146" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.227451 0 0 0 0 0.694118 0 0 0 0 0.996078 0 0 0 0.5 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_541_11003" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_541_11003" result="shape" />
        </filter>
        
        <clipPath id="bgblur_1_541_11003_clip_path" transform="translate(-4.65172 -17.5619)">
          <path d="M19.9988 40.6632C19.516 40.6632 19.0331 40.4701 18.6645 40.0817L13.549 34.6914C12.8118 33.9145 12.8118 32.6561 13.549 31.8815C14.2863 31.1046 15.4784 31.1024 16.2156 31.8792L19.9988 35.8657L28.8975 26.4889C29.6348 25.712 30.8269 25.712 31.5641 26.4889C32.3013 27.2658 32.3013 28.5242 31.5641 29.301L21.3332 40.0817C20.9646 40.4701 20.4817 40.6632 19.9988 40.6632Z" />
        </clipPath>
        
        <linearGradient
          id="paint0_linear_541_11003"
          x1="57.0013"
          y1="9.19761"
          x2="23.0031"
          y2="28.9444"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#68D7FF" />
          <stop offset="1" stopColor="#2DA0FF" />
        </linearGradient>
        
        <linearGradient
          id="paint1_linear_541_11003"
          x1="7.863"
          y1="15.863"
          x2="37.1256"
          y2="50.2573"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.25" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        
        <linearGradient
          id="paint2_linear_541_11003"
          x1="30.7614"
          y1="28.5711"
          x2="9.47781"
          y2="29.4702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.2" />
        </linearGradient>
        
        <linearGradient
          id="paint3_linear_541_11003"
          x1="15.0558"
          y1="30.8565"
          x2="31.2918"
          y2="30.9726"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default TickUnChangedIcon;
